module.exports = __webpack_public_path__ + "b31dabb7254c788be85f74723d50690b.png";